import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { rateCreateToDto, rateFromDto, rateListFromDto, rateUpdateToDto } from '@/features/agreements/mappers/ratesMapper';
import { validateRequiredFields } from '@/shared/utils/validateRequiredFields';

const BASE_ENDPOINT = 'agreements';

const buildServiceEndpoint = ({ agreementId, planId, rateId, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id: agreementId }, ['plans', planId, 'rates', rateId, action]);
};

export const getRates = async (agreementId, planId, data = {}) => {
  validateRequiredFields({ agreementId, planId });

  const params = {
    active: data.active,  // Opcional. Si no se proporciona, se retornan todos los rates
  };

  const endpoint = buildServiceEndpoint({ agreementId, planId });
  const response = await api.get(endpoint, { params });
  return response.data.map(rateListFromDto);
};

export const getRate = async (agreementId, planId, rateId) => {
  validateRequiredFields({ agreementId, planId, rateId });

  const endpoint = buildServiceEndpoint({ agreementId, planId, rateId });
  const response = await api.get(endpoint);
  return rateFromDto(response.data);
};

export const createRate = async (agreementId, planId, data) => {
  validateRequiredFields({ agreementId, planId });

  const payload = rateCreateToDto(data);
  const endpoint = buildServiceEndpoint({ agreementId, planId });
  const response = await api.post(endpoint, payload);
  return rateFromDto(response.data);
};

export const updateRate = async (agreementId, planId, rateId, data) => {
  validateRequiredFields({ agreementId, planId, rateId });

  const payload = rateUpdateToDto(data);
  const endpoint = buildServiceEndpoint({ agreementId, planId, rateId });
  const response = await api.put(endpoint, payload);
  return rateFromDto(response.data);
};

/** El endpoint responde con un código 204 (No Content), por lo que no se retorna ningún valor. */
export const deleteRate = async (agreementId, planId, rateId) => {
  validateRequiredFields({ agreementId, planId, rateId });

  const endpoint = buildServiceEndpoint({ agreementId, planId, rateId });
  await api.delete(endpoint);
};

export const restoreRate = async (agreementId, planId, rateId) => {
  validateRequiredFields({ agreementId, planId, rateId });

  const endpoint = buildServiceEndpoint({ agreementId, planId, rateId, action: 'restore' });
  const response = await api.post(endpoint);
  return rateFromDto(response.data);
};
